import messages from './share-modal-translations';

export default {
    name: 'instamapsShareModal',
    data() {
        return {
            currentUrl: document.URL,
        };
    },
    i18n: {
        messages,
    },
    props: {
        mapName: { type: String },
        show: { type: Boolean },
    },
    computed: {
        mailTo: function () {
          return 'mailto:?subject=Mapa%20InstaMaps&body=' + this.mapName + ' - Fet amb InstaMaps.cat - ' + this.currentUrl;
        }
    },
    methods: {
        dismiss: function () {
            this.$emit('closeShareModal');
        },
    },
};



// WEBPACK FOOTER //
// ./src/map-viewer/components/share-modal/share-modal.js